import React from 'react';

function getOrientation() {
  return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
}

export function useWindowOrientation() {
  const [orientation, setOrientation] = React.useState<'landscape' | 'portrait'>(getOrientation());

  function onOrientationChange() {
    setOrientation(getOrientation());
  }

  React.useEffect(() => {
    window.addEventListener('resize', onOrientationChange);
    return () => window.removeEventListener('resize', onOrientationChange);
  }, [setOrientation]);

  return orientation;
}
